<!-- Sidebar -->
<aside
  class="h-full py-8 bg-cyan-950 dark:bg-[#161718] dark:border-r dark:border-surface-800 text-white flex flex-col justify-between gap-20 items-start overflow-y-auto overflow-x-hidden"
  [class]="isCollapsed() ? 'w-20 px-5' : 'w-72 px-7'">
  <div class="flex flex-col gap-20 w-full">
    @if (!isCollapsed()) {
    <img alt="Logo" height="55" ngSrc="logo.png" priority width="575" />
    } @else {
    <div class="flex justify-center">
      <img alt="Logo" height="20" ngSrc="logo-short.png" priority width="10" />
    </div>
    }

    <!-- Navigation Menu -->
    <nav class="flex flex-col gap-8">
      <div>
        @if (!isCollapsed()) {
        <h3 class="text-base font-semibold text-white mb-6">Main Menu</h3>
        }
        <ul class="space-y-1">
          <li>
            <a
              app-sidebar-item
              icon="pi pi-folder"
              label="Cases"
              routerLink="case"
              [isCollapsed]="isCollapsed()"
              [pTooltip]="isCollapsed() ? 'Cases' : ''">
            </a>
          </li>
        </ul>
      </div>
      <hr class="border-t border-slate-600 dark:border-surface-700" />
      @if(isAdmin()) {
      <div>
        @if (!isCollapsed()) {
        <h3 class="text-base font-semibold text-white mb-6">Admin</h3>
        }
        <ul class="space-y-1">
          <li>
            <a
              app-sidebar-item
              icon="pi pi-users"
              label="Users"
              routerLink="user"
              [isCollapsed]="isCollapsed()"
              [pTooltip]="isCollapsed() ? 'Users' : ''">
            </a>
          </li>
        </ul>
      </div>

      <hr class="border-t border-slate-600 dark:border-surface-700" />
      }
      <div>
        @if (!isCollapsed()) {
        <h3 class="text-base font-semibold text-white mb-6">Display</h3>
        <ng-container [ngTemplateOutlet]="displayControls" />
        } @else {
        <div class="flex justify-center">
          <button
            aria-haspopup="dialog"
            aria-label="Display settings"
            class="flex items-center justify-center w-9 h-9 rounded-md text-slate-300 hover:bg-slate-600 dark:hover:bg-white/10 hover:text-white transition-colors"
            pTooltip="Display"
            type="button"
            (click)="displayPopover.toggle($event)">
            <i aria-hidden="true" class="pi pi-sliders-h"></i>
          </button>
        </div>
        <p-popover #displayPopover ariaLabel="Display settings" [dt]="popoverTokens()">
          <div class="w-60 text-white">
            <ng-container [ngTemplateOutlet]="displayControls" />
          </div>
        </p-popover>
        }
      </div>
    </nav>
    <!-- End of Navigation Menu -->
  </div>

  <div class="flex flex-col gap-3 w-full">
    <button
      class="flex items-center gap-3 py-2 rounded-md text-slate-300 hover:bg-slate-600 dark:hover:bg-white/10 hover:text-white transition-colors"
      type="button"
      [attr.aria-expanded]="!isCollapsed()"
      [attr.aria-label]="isCollapsed() ? 'Expand sidebar' : 'Collapse sidebar'"
      [class]="isCollapsed() ? 'justify-center' : 'px-3'"
      [pTooltip]="isCollapsed() ? 'Expand sidebar' : ''"
      (click)="toggleSidebar()">
      <i aria-hidden="true" [class]="isCollapsed() ? 'pi pi-angle-double-right' : 'pi pi-angle-double-left'"></i>
      @if (!isCollapsed()) {
      <span class="text-sm">Collapse</span>
      }
    </button>

    @if(!isCollapsed()) {
    <div class="flex items-center gap-3 w-full pt-5 border-t border-slate-600 dark:border-surface-700">
      <span
        aria-hidden="true"
        class="flex items-center justify-center w-9 h-9 rounded-full bg-primary text-cyan-950 text-sm font-semibold flex-shrink-0">
        {{ initials() }}
      </span>
      <div class="flex flex-col min-w-0 flex-1">
        <span class="text-sm font-semibold truncate" [title]="userName()">{{ userName() }}</span>
        <span class="text-xs text-slate-300 dark:text-surface-400">{{ isAdmin() ? 'Admin' : 'Standard user' }}</span>
      </div>
      <button
        aria-label="Log out"
        class="flex items-center justify-center w-9 h-9 rounded-md text-slate-300 hover:bg-slate-600 dark:hover:bg-white/10 hover:text-white transition-colors flex-shrink-0"
        pTooltip="Log out"
        type="button"
        (click)="logout.emit()">
        <i aria-hidden="true" class="pi pi-sign-out"></i>
      </button>
    </div>
    } @else {
    <div class="flex flex-col items-center gap-3 w-full pt-5 border-t border-slate-600 dark:border-surface-700">
      <span
        class="flex items-center justify-center w-9 h-9 rounded-full bg-primary text-cyan-950 text-sm font-semibold"
        [attr.aria-label]="userName()"
        [pTooltip]="userName()">
        {{ initials() }}
      </span>
      <button
        aria-label="Log out"
        class="flex items-center justify-center w-9 h-9 rounded-md text-slate-300 hover:bg-slate-600 dark:hover:bg-white/10 hover:text-white transition-colors"
        pTooltip="Log out"
        type="button"
        (click)="logout.emit()">
        <i aria-hidden="true" class="pi pi-sign-out"></i>
      </button>
    </div>
    }
  </div>
</aside>
<!-- End of Sidebar -->

<ng-template #displayControls>
  <div class="flex flex-col gap-5">
    <div class="flex flex-col gap-2">
      <span class="text-sm text-slate-300" id="text-size-label">Text size</span>
      <div
        aria-labelledby="text-size-label"
        class="grid grid-cols-3 gap-1 p-1 rounded-lg bg-cyan-900/70 dark:bg-white/5"
        role="radiogroup">
        @for (size of fontSizes; track size) {
        <button
          class="flex items-center justify-center h-9 rounded-md transition-colors"
          role="radio"
          type="button"
          [attr.aria-checked]="size === fontSize()"
          [attr.aria-label]="size + 'px'"
          [class]="size === fontSize() ? 'bg-white text-cyan-950 dark:bg-[#2482a8]/30 dark:text-white dark:shadow-none font-semibold shadow-sm' : 'text-slate-300 dark:text-white/80 hover:bg-slate-600 dark:hover:bg-white/10 hover:text-white'"
          [pTooltip]="size + 'px'"
          (click)="fontSizeChange.emit(size)">
          <span aria-hidden="true" class="leading-none" [style.font-size.px]="fontSizeGlyphs[size]">A</span>
        </button>
        }
      </div>
    </div>
    <div class="flex flex-col gap-2">
      <span class="text-sm text-slate-300" id="theme-label">Theme</span>
      <div
        aria-labelledby="theme-label"
        class="grid grid-cols-2 gap-1 p-1 rounded-lg bg-cyan-900/70 dark:bg-white/5"
        role="radiogroup">
        @for (option of themes; track option.value) {
        <button
          class="flex items-center justify-center gap-2 h-9 rounded-md text-sm transition-colors"
          role="radio"
          type="button"
          [attr.aria-checked]="option.value === theme()"
          [class]="option.value === theme() ? 'bg-white text-cyan-950 dark:bg-[#2482a8]/30 dark:text-white dark:shadow-none font-semibold shadow-sm' : 'text-slate-300 dark:text-white/80 hover:bg-slate-600 dark:hover:bg-white/10 hover:text-white'"
          (click)="themeChange.emit(option.value)">
          <i aria-hidden="true" [class]="option.icon"></i>
          {{ option.label }}
        </button>
        }
      </div>
    </div>
  </div>
</ng-template>
